import React, { useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";

import Modal from "react-modal";

import Pagination from "../../../components/Pagination";
import { Collapse } from "antd";
const { Panel } = Collapse;

const MarketSurvey = () => {
  const [data, setData] = useState([]);

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      zIndex: 1000,
    },
    content: {
      top: "55%",
      left: "55%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "800px", // Adjust the width as needed
      height: "80%",
      minHeight: "400px",
      overflow: "auto",
    },
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const openModal = (data) => {
    //console.log(data);

    const Id = data && data.marketSurveyId;

    getMarketSurvey(
      {
        url: `/api/marketSurvey/?orgId=${localStorage.getItem(
          "orgId"
        )}&marketSurveyId=${Id}`,
      },
      (res) => {
        //console.log(res);
        setSelectedData(res.marketSurvey);
      }
    );

    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };
  const { sendRequest: getMarketSurvey } = useHttp();

  const getData = () => {
    getMarketSurvey(
      {
        url: `/api/marketSurvey/?orgId=${localStorage.getItem(
          "orgId"
        )}&empId=${localStorage.getItem("empId")}`,
      },
      (res) => {
        if (res) {
          const sortedData =
            res.marketSurvey &&
            res.marketSurvey.sort(
              (a, b) => b.marketSurveyId - a.marketSurveyId
            );

          setData(sortedData);

          //console.log(res);
        }
      }
    );
  };

  useEffect(() => {
    getData();
  }, []);
  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <label className="card-title mx-3 my-3">Market Survey</label>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered table-sm text-center">
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Survey No</th>

                          <th>Customer Name</th>
                          <th>Executive Name</th>
                          <th>Survey For</th>
                          <th>Product Name</th>
                          <th>View</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((x, i) => {
                            return (
                              <tr key={i}>
                                <td>{x.surveyDate}</td>
                                <td>{x.docNo}</td>
                                <td>{x.customerName}</td>
                                <td>{x.marketSurveyBy}</td>

                                <td>{x.surveyFor}</td>
                                <td>{x.productName}</td>

                                <td>
                                  <button
                                    className="btn"
                                    onClick={() => openModal(x)}
                                  >
                                    <i className="fas fa-eye"></i>
                                  </button>
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Modal isOpen={isModalOpen} style={customModalStyles}>
        {selectedData && (
          <div className="mx-3">
            <h4 className="card-title">Market Survey Details</h4>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setIsModalOpen(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>

            <div className="row">
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Market Survey No: {selectedData.docNo}
              </p>
              <p className="col-md-6">
                Market Survey Date : {selectedData.surveyDate}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Field Executive Name: {selectedData.marketSurveyBy}
              </p>
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Customer Name: {selectedData.customerName}
              </p>
            </div>

            <div className="row">
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Survey For: {selectedData.surveyFor}
              </p>

              <p className="col-md-6">
                Competitor Name : {selectedData.competitorName}
              </p>
            </div>

            <div className="row">
              <p className="col-md-6">SKU Size: {selectedData.skuSize}.</p>
              <p className="col-md-6">
                SKU Unit: {selectedData.skuSizeUnitName}.
              </p>
            </div>

            <h4 className="card-title"> Survey Details</h4>
            <br />
            {selectedData.marketSurveyHeadFieldListList &&
              selectedData.marketSurveyHeadFieldListList.map((x, index) => (
                <>
                  <Collapse>
                    <Panel
                      header={x.marketSurveyHeadName}
                      key={index + 1}
                      // className={isGreen(index) ? "panel-green" : "panel-orange"}
                    >
                      {x.marketSurveyHeadList &&
                        x.marketSurveyHeadList.map((item, itemIndex) => (
                          <>
                            <b htmlFor={"accordion_label"}>
                              {item.marketSurveyFieldName}
                            </b>{" "}
                            <br />
                            <p htmlFor={"accordion_label"}>
                              Observation : {item.observation}{" "}
                            </p>
                          </>
                        ))}
                    </Panel>
                  </Collapse>
                  <br />
                </>
              ))}
          </div>
        )}
      </Modal>
    </>
  );
};

export default MarketSurvey;
